module.exports = __webpack_public_path__ + "img/callipers1.597ae41b.png";